import { resolveAppOrigin } from "./resolveAppOrigin";

type BrowserGlobal = typeof globalThis & {
  location?: { origin: string };
};

export function appOrigin(): string {
  const browserLocation = (globalThis as BrowserGlobal).location;

  if (browserLocation) {
    return resolveAppOrigin(browserLocation.origin, undefined);
  }

  return resolveAppOrigin(undefined, process.env.APP_URL);
}
